import type { UseQueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import { apiWithoutCamelization } from "../../../api";
import urls from "../../../urls";
import type { EnergyRevenuesListResponse } from "../RevenueMonitoring.types";
import { ensureListResponse } from "./ensureListResponse";

export function usePersonEnergyRevenuesData(
  personId?: number,
  options?: Partial<UseQueryOptions<EnergyRevenuesListResponse>>
) {
  return useQuery({
    queryKey: ["energyRevenuesData", { personId }],
    queryFn: ({ client, queryKey }) =>
      fetchEnergyRevenuesData(
        personId,
        // Kept on screen if a refetch returns a non-array body
        client.getQueryData<EnergyRevenuesListResponse>(queryKey)
      ),
    enabled: !!personId,
    retry: false,
    ...options
  });
}

async function fetchEnergyRevenuesData(
  personId: number | undefined,
  cachedData: EnergyRevenuesListResponse | undefined
) {
  if (!personId) return [];

  const revenueMonitoringPerPersonUrl =
    urls.apiWithoutCamelization.revenueMonitoringPerPerson({ personId });
  const response = await apiWithoutCamelization.get<unknown>(
    revenueMonitoringPerPersonUrl
  );
  return ensureListResponse(response, "person", cachedData);
}
